export default "/img/VU.86d00f2e3107a316d6d1d173d8f18cdd.png";